import _ from 'lodash';
import PropTypes from 'prop-types';
import BrowseButton from './BrowseButton.js';
import DeleteButton from './DeleteButton.js';
import { gu_auth } from "src/lib/authentication.js";

let count = 0;
const EVENTS = [
	'PostInit', 'Browse', 'Refresh', 'StateChanged', 'QueueChanged', 'OptionChanged',
	'BeforeUpload', 'UploadProgress', 'FileFiltered', 'FilesAdded', 'FilesRemoved', 'FileUploaded', 'ChunkUploaded',
	'UploadComplete', 'Destroy', 'Error'
];

class Plupload extends React.Component {
	constructor() {
		super();
		this.id = new Date().valueOf();
		this.state = {
			files: [],
			uploadState: false,
			progress: {},
			profileStored: false,
			uploadText: 'No file has been chosen yet'
		};
		this.runUploader = this.runUploader.bind(this);
		this.getComponentId = this.getComponentId.bind(this);
		this.refresh = this.refresh.bind(this);
		this.initUploader = this.initUploader.bind(this);
		this.list = this.list.bind(this);
		this.clearAllFiles = this.clearAllFiles.bind(this);
		this.clearFailedFiles = this.clearFailedFiles.bind(this);
		this.removeFile = this.removeFile.bind(this);
		this.doUpload = this.doUpload.bind(this);
		this.deleteUpload = this.deleteUpload.bind(this);
		this.container = null;
	}

	checkUploader() {
		return window.plupload !== undefined;
	}

	runUploader() {
		const self = this;
		this.initUploader();
		this.uploader.init();

		EVENTS.forEach(function (event) {
			const handler = self.props['on' + event];
			if (typeof handler === 'function') {
				self.uploader.bind(event, handler);
			}
		});

		// Put the selected files into the current state
		this.uploader.bind('FilesAdded', (up, files) => {
			if (_.get(self.props, 'multi_selection') === false) {
				self.clearAllFiles();
			} else {
				self.clearFailedFiles();
			}

			const f = self.state.files;
			_.map(files, (file) => {
				f.push(file);
			});
			self.setState({
				files: f
			}, () => {
				if (self.props.autoUpload === true) {
					self.uploader.start();
				}
			});
		});

		this.uploader.bind('FilesRemoved', (up, rmFiles) => {
			const stateFiles = self.state.files;
			const files = _.filter(stateFiles, (file) => {
				// console.log(rmFiles, file);
				return -1 !== _.find(rmFiles, {
					id: file.id
				});
			});
			self.setState({
				files: files
			});
		});

		this.uploader.bind('StateChanged', (up) => {
			if (up.state === window.plupload.STARTED && self.state.uploadState === false) {
				self.setState({
					uploadState: true
				});
			}
			if (up.state !== window.plupload.STARTED && self.state.uploadState === true) {
				self.setState({
					uploadState: false
				});
			}
		});

		this.uploader.bind('FileUploaded', (up, file, result) => {
			const stateFiles = self.state.files;
			_.map(stateFiles, (val, key) => {
				if (val.id === file.id) {
					val.uploaded = true;
					stateFiles[key] = val;
				}
			});
			self.setState({
				files: stateFiles,
				profileStored: true
			});

			self.props.refreshImageData(result.response);
		});

		this.uploader.bind('Error', (up, err) => {
			console.log('Error!', err);
			if (err.message === "File size error.") {
				self.setState({
					uploadText: "Image must not exceed 2MB",
					files: [],
					profileStored: false
				});
			}
			if (_.isUndefined(err.file) !== true) {
				const stateFiles = self.state.files;
				_.map(stateFiles, (val, key) => {
					if (val.id === err.file.id) {
						val.error = err;
						stateFiles[key] = val;
					}
				});
				self.setState({
					files: stateFiles
				});
			}
		});

		this.uploader.bind('UploadProgress', (up, file) => {
			const stateProgress = self.state.progress;
			stateProgress[file.id] = file.percent;
			self.setState({
				progress: stateProgress
			});
		});
	}

	componentDidMount() {
		const self = this;
		if (this.checkUploader()) {
			this.runUploader();
			self.setState({
				profileStored: self.props.hasAvatar
			});
		} else {
			setTimeout(function () {
				if (self.checkUploader()) {
					self.runUploader();
				} else {
					console.warn('Plupload has not initialized');
				}
			}, 500);
		}
	}

	componentDidUpdate() {
		if (this.checkUploader()) {
			this.refresh();
		}
	}

	getComponentId() {
		return this.props.id || 'react_plupload_' + this.id;
	}

	refresh() {
		// Refresh to append events to buttons again.
		this.uploader.refresh();
	}

	initUploader() {
		this.uploader = new window.plupload.Uploader(_.extend({
			container: `plupload_${this.props.id}`,
			runtimes: 'html5,flash,silverlight',
			filters: [{
				title: 'Image files',
				extensions: 'jpg,jpeg,gif,png'
			}],
			max_file_size: '2mb',
			browse_button: this.getComponentId(),
			url: '/upload',
			headers: {
				Authorization: gu_auth.fn.getActiveToken()
			}
		}, this.props));
	}

	// Display selected files
	list() {
		const self = this;
		if (this.state.files.length < 1) {
			return React.createElement('div', {
					className: 'progress'
				},
				React.createElement('div', {
						className: 'progress-bar',
						role: 'progressbar',
						'aria-valuenow': 0,
						'aria-valuemin': 0,
						'aria-valuemax': 100,
						style: {
							width: '0%'
						}
					}, self.state.uploadText
				)
			);
		} else {
			return _.map(this.state.files, (val) => {

				const removeFile = (e) => {
					e.preventDefault();
					self.removeFile(val.id);
				};
				let delButton = '';
				if (self.state.uploadState === false && val.uploaded !== true) {
					delButton = React.createElement('button', {
						onClick: removeFile,
						className: 'pull-right'
					}, 'X');
				}
	
				let progressBar = '';
				const percent = self.state.progress[val.id] || 0;
				var progress = percent + '%';
				progressBar = React.createElement('div', {
						className: 'progress'
					},
					React.createElement('div', {
							className: 'progress-bar',
							role: 'progressbar',
							'aria-valuenow': percent,
							'aria-valuemin': 0,
							'aria-valuemax': 100,
							style: {
								width: percent + '%'
							}
						},
						React.createElement('span', {}, progress)
					)
				);
	
				let errorDiv = '';
				if (!_.isUndefined(val.error)) {
					errorDiv = React.createElement('div', {
						className: 'alert alert-danger'
					}, 'Error: ' + val.error.code + ', Message: ' + val.error.message);
				}
	
				let bgSuccess = '';
				if (!_.isUndefined(val.uploaded)) {
					bgSuccess = 'bg-success';
				}
	
				return React.createElement('div', {
						key: val.id
					},
					React.createElement('p', {
						className: bgSuccess
					}, val.name, ' ', delButton), progressBar, errorDiv
				);
			});
		}
		
	}

	clearAllFiles() {
		const state = _.filter(this.state.files, (file) => {
			this.uploader.removeFile(file.id);
		});
		this.setState({
			files: state
		});
	}

	clearFailedFiles() {
		const state = _.filter(this.state.files, (file) => {
			if (file.error) {
				this.uploader.removeFile(file.id);
			}
			return !file.error;
		});
		this.setState({
			files: state
		});
	}

	removeFile(id) {
		this.uploader.removeFile(id);
		const state = _.filter(this.state.files, (file) => {
			return file.id !== id;
		});
		this.setState({
			files: state
		});
	}

	doUpload(e) {
		e.preventDefault();
		this.uploader.start();
	}

	deleteUpload(e) {
		e.preventDefault();
		this.props.deleteProfileImage();
		this.setState({
			files: [],
			profileStored: false,
			uploadText: 'No file has been chosen yet'
		});
	}

	render() {
		const propsSelect = {
			id: this.getComponentId(),
			type: 'button',
			className: 'btn profile-upload__btn',
			content: this.props.buttonSelect || 'Browse'
		};

		const propsUpload = {
			onClick: this.doUpload,
			type: 'button',
			className: 'btn btn-light profile-upload__delete',
			content: this.props.buttonUpload || (<span>Upload</span>)
		};
		if (this.state.files.length === 0) propsUpload.disabled = 'disabled';

		const propsDelete = {
			onClick: this.deleteUpload,
			type: 'button',
			className: 'btn btn-light profile-upload__delete',
			content: this.props.buttonDelete || 'Delete'
		};
		if (!this.state.profileStored) propsDelete.disabled = 'disabled';

		const list = this.list();

		return (
			<div id={`plupload_${this.props.id}`} className = {this.props.classList} ref = {ref => (this.container = ref)} >
				<div className="profile-upload__buttons">
					<BrowseButton {...propsSelect} />
					<DeleteButton {...propsDelete} />
				</div>
				

				{list}

			</div>
		);
	}
}

Plupload.propTypes = {
	'onPostInit': PropTypes.func,
	'onBrowse': PropTypes.func,
	'onRefresh': PropTypes.func,
	'onStateChanged': PropTypes.func,
	'onQueueChanged': PropTypes.func,
	'onOptionChanged': PropTypes.func,
	'onBeforeUpload': PropTypes.func,
	'onUploadProgress': PropTypes.func,
	'onFileFiltered': PropTypes.func,
	'onFilesAdded': PropTypes.func,
	'onFilesRemoved': PropTypes.func,
	'onFileUploaded': PropTypes.func,
	'onChunkUploaded': PropTypes.func,
	'onUploadComplete': PropTypes.func,
	'onDestroy': PropTypes.func,
	'onError': PropTypes.func,
	'id': PropTypes.string.isRequired,
	'buttonSelect': PropTypes.object,
	'buttonUpload': PropTypes.string,
	'autoUpload': PropTypes.bool
};

export default Plupload;